import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CompanyState } from "./types";
import CompanyService from "@/services/company.service";
import { AxiosError, AxiosResponse } from "axios";
import toast from "@/functions/toast.function";
const service: CompanyService = new CompanyService();

export const actions: ActionTree<CompanyState, RootState> = {};
